// src/components/common/SortableHeader.jsx
import React from "react";
import { ArrowUpDown, ArrowUp, ArrowDown, ChevronsUpDown, ChevronUp, ChevronDown } from "lucide-react";

const SortableHeader = ({ 
  children, 
  column, 
  sortBy, 
  sortOrder, 
  onSort, 
  className = "" 
}) => {
  const isActive = sortBy === column;
  const Icon = isActive 
    ? sortOrder === "ASC" ? ChevronUp  : ChevronDown 
    : ChevronsUpDown ;

  return (
    <button
      onClick={() => onSort(column)}
      className={`flex items-center gap-1 hover:text-foreground/80 ${className}`}
    >
      {children}
      <Icon className="h-4 w-4" />
    </button>
  );
};

export default SortableHeader;